import * as React from "react";
import { SVGProps } from "react";

const CheckboxCheckedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      stroke={props.color}
      strokeWidth={2}
      d="M1 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Z"
    />
    <path fill={props.color} d="M5 5h6v6H5z" />
    <path stroke={props.color} strokeWidth={2} d="M5 5h6v6H5z" />
  </svg>
);
export default CheckboxCheckedIcon;
